export const PURCHASE_METHODS = {
  TRANSFER: 'transfer',
  GIFT: 'gift',
  SUPER_PASS: 'superPass',
  PACKS: 'packs'
}

/**
 * ЧПУ продуктовых витрин — один источник правды для роутера, меню и карточек
 * на главной. Раньше витрины жили на /purchase?<метод>=true, но такие адреса
 * закрыты в robots.txt (Disallow: /*?) и в индекс не попадали.
 */
export const PURCHASE_PATHS = {
  [PURCHASE_METHODS.TRANSFER]: '/transfer',
  [PURCHASE_METHODS.GIFT]: '/giftcards',
  [PURCHASE_METHODS.SUPER_PASS]: '/superpass',
  [PURCHASE_METHODS.PACKS]: '/packs'
}

// Query-флаги старых витрин: /purchase?gift=true → /giftcards
const LEGACY_METHOD_FLAGS = {
  packs: PURCHASE_METHODS.PACKS,
  gift: PURCHASE_METHODS.GIFT,
  superPass: PURCHASE_METHODS.SUPER_PASS
}

/**
 * Куда вести со старого /purchase. Метод определяется query-флагом, остальные
 * параметры (utm-метки, robux) сохраняются — их теряет только сам флаг.
 */
export function resolveLegacyPurchaseRoute(query = {}) {
  const flag = Object.keys(LEGACY_METHOD_FLAGS).find(key => query[key])
  const rest = { ...query }

  Object.keys(LEGACY_METHOD_FLAGS).forEach(key => delete rest[key])

  return {
    path: PURCHASE_PATHS[flag ? LEGACY_METHOD_FLAGS[flag] : PURCHASE_METHODS.TRANSFER],
    query: rest
  }
}
